import { render, staticRenderFns } from "./WebsiteImagesCrud.vue?vue&type=template&id=8cb3ef9a"
import script from "./WebsiteImagesCrud.vue?vue&type=script&lang=js"
export * from "./WebsiteImagesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports